import { currenciesConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  fetched: false,
  request: null,
  response: null,
  error: null
};

export const viewCurrency = (state = initialState, action) => {
  switch (action.type) {
    case currenciesConstants.VIEW_CURRENCY_REQUEST:
      return {
        ...state,
        fetching: true,
        fetched: false,
        request: action.id,
        response: null,
        error: null
      };
    case currenciesConstants.VIEW_CURRENCY_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case currenciesConstants.VIEW_CURRENCY_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        response: null,
        error: action.error
      };
    case currenciesConstants.VIEW_CURRENCY_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
